import { Shadows } from '@mui/material/styles/shadows'

const elevation = {
  // Here is where you can define your own shadows AKA "elevation" on Figma TSL Design Systems.
  // This will override the default Mui shadows.

  1: '0px 0px 1px rgba(40, 41, 61, 0.2), 0px 0.5px 2px rgba(96, 97, 112, 0.08), 0px 0px 2px rgba(0, 163, 255, 0.25)',
  2: '0px 0px 1px rgba(40, 41, 61, 0.04), 0px 2px 4px rgba(96, 97, 112, 0.2), 0px 1px 4px rgba(0, 163.2, 255, 0.14)',
  3: 'none',
  4: '0px 2px 4px rgba(40, 41, 61, 0.2), 0px 1px 10px rgba(96, 97, 112, 0.12), 0px 4px 5px rgba(0, 163, 255, 0.14)',
  5: 'none',
  6: 'none',
  7: 'none',
  8: '0px 5px 5px rgba(40, 41, 61, 0.2), 0px 3px 14px rgba(96, 97, 112, 0.12), 0px 8px 10px rgba(0, 163, 255, 0.14)',
  9: 'none',
  10: 'none',
  11: 'none',
  12: 'none',
  13: 'none',
  14: 'none',
  15: 'none',
  16: '0px 8px 10px rgba(40, 41, 61, 0.2), 0px 6px 30px rgba(96, 97, 112, 0.12), 0px 16px 24px rgba(0, 163, 255, 0.14)',
  17: 'none',
  18: 'none',
  19: 'none',
  20: 'none',
  21: 'none',
  22: 'none',
  23: 'none',
  24: '0px 11px 15px rgba(40, 41, 61, 0.2), 0px 9px 46px rgba(96, 97, 112, 0.12), 0px 24px 38px rgba(0, 163, 255, 0.14)',
}

export const shadows: Shadows = [
  'none',
  elevation[1],
  elevation[2],
  elevation[3],
  elevation[4],
  elevation[5],
  elevation[6],
  elevation[7],
  elevation[8],
  elevation[9],
  elevation[10],
  elevation[11],
  elevation[12],
  elevation[13],
  elevation[14],
  elevation[15],
  elevation[16],
  elevation[17],
  elevation[18],
  elevation[19],
  elevation[20],
  elevation[21],
  elevation[22],
  elevation[23],
  elevation[24],
]
